import { render, staticRenderFns } from "./BookerDetails.vue?vue&type=template&id=7bf58868"
import script from "./BookerDetails.vue?vue&type=script&lang=js"
export * from "./BookerDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports